<app-generic-header [goBack]="closePromo.bind(this)" variant="back">
</app-generic-header>

<ion-content>

  <div class="closeButton">
    <ion-icon name="close-circle" (click)="closePromo()" class="closeCircle" ></ion-icon>
  </div>

  <div class="whiteDiv">
    <div class="topicLogo">
      <img  class="topicLogoMain" src="./assets/imgs/flamrplus.svg">
    </div>
    <div class="topText">
      <h1 class="titlePage avocadoTitle">
        {{'avocadoClub' | translate}}
      </h1>
    </div>
    <div class="advantageClubDiv">
      <span class="advantageClubText">
        {{'vegglyAdvantagesClub' | translate}}
      </span>
    </div>
    <!-- <div class="discountDivAnimationContainer" *ngIf="!purchaseServiceProvider.club_30percent_off_PriceSet"></div>
    <div class="discountDiv" *ngIf="purchaseServiceProvider.club_30percent_off_PriceSet">
      <span class="discountText">
        {{'discountOf' | translate}}
      </span>
      <span class="discountPercentage">
        {{formatNoDecimal(purchaseServiceProvider.club_30percent_off_Discount)}}%
      </span>
    </div>

    <div class="fromForDivAnimationContainer" *ngIf="!purchaseServiceProvider.club_30percent_off_PriceSet"></div>
    <div *ngIf="purchaseServiceProvider.club_30percent_off_PriceSet">
      <svg height="130" width="100%" class="svgClass">
        <polygon points="110,20 308,29 303,111 130,110" class="greenBox" />
        <polygon points="100,20 300,22 300,105 106,105" class="pinkBox" />
      </svg>
    </div>
    
    <div class="fromForDiv" *ngIf="purchaseServiceProvider.club_30percent_off_PriceSet">
      <span class="fromText">
        {{'from' | translate}}
      </span>
     
      <span class="fromValueText">
        {{purchaseServiceProvider.clubPrice}}
      </span>
      <br>
      <span class="fromText">
        {{'forPrice' | translate}}
      </span>
      <span class="forValueText">
        {{purchaseServiceProvider.club_30percent_off_Price}}
      </span>

    </div> -->

    <div class="advantagesDiv">
      <span class="knowTheAdvantages">
        {{'knowAboutAdvantages' | translate}}
      </span><br>
      <span class="oneAdvantage">
        <img class="checkImage" src="assets/imgs/check.png">&nbsp;{{'seeWhoLikedYou' | translate}}<br>
        <img class="checkImage" src="assets/imgs/check.png">&nbsp;{{'noAds' | translate}}<br>
        <img class="checkImage" src="assets/imgs/check.png">&nbsp;3 {{'vegglyCoins' | translate}} {{'perMonth' | translate}}<br>
        <img class="checkImage" src="assets/imgs/check.png">&nbsp;{{'teleportation' | translate}}<br>
        <img class="checkImage" src="assets/imgs/check.png">&nbsp;{{'chatReadConfirmation' | translate}}<br>
        
      </span>

    </div>

    <div class="promotionEndsDiv">
      <span class="promotionEndsText">
        {{'promotionEndsIn' | translate}}: 
      </span>
      <span id="timeLeftSpan" class="promotionEndsText">
        {{timeLeft}}
      </span>
    </div>

    <div class="joinDiv">
      <button ion-button class="joinDivButton" (click)="join()">
        {{('joinClub' | translate)}}
      </button>
    </div>

    <div class="subscriptionExplanationDiv">
      <span class="subscriptionExplanationText">
        {{('subscriptionExplanation' | translate)}}<br>
        {{('reducedPriceValidTillCancel' | translate)}}
      </span>
    </div>

    

  </div>
  <div class="gradientDiv"></div>

</ion-content>
